/* eslint-disable camelcase */
import { privateFetcher } from 'services';

import APIError from 'exceptions/APIError';
import ENDPOINTS from 'constants/endpoints.constants';
import { EDD_V2_SOURCE } from '@pperform/pp-constants/parcel';
import { EddDTOResponse } from 'components/EstimatedDeliveryDate/fetchers/edd.fetcher.dto';

interface EddSingleResponse {
  data: EddDTOResponse;
}

export const fetchSingleEddBySource = async (
  orgId: number,
  shipmentPk: number,
  eddSource: typeof EDD_V2_SOURCE[keyof typeof EDD_V2_SOURCE],
): Promise<EddSingleResponse> => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/${orgId}/edd-result/${shipmentPk}/${eddSource}`;
    const { data } = await privateFetcher.get(url);

    return data;
  } catch (error) {
    if (error.response) {
      throw new APIError(error.response.data?.message, error);
    }

    throw error;
  }
};
